import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Calculator/YtongCalculator/ytongCalculator.container"
    ).then((module) => ({
        default: module.YtongCalculator
    }))
);
